<script>
  import FlowProgram from './components/pages/FlowProgram/FlowProgram.svelte';
  import Router from 'svelte-spa-router';
  import Main from './components/Main.svelte';
  import TokenSave from './components/TokenSave.svelte';
  import PublicatePage from './components/pages/Publicate/PublicatePage.svelte';
  import TokenError from './components/Errors/TokenError.svelte';
  import AccessError from './components/Errors/AccessError.svelte';
  import Logout from './components/Logout.svelte';
  import PreviewPublicatePage from './components/pages/Publicate/PreviewPublicatePage.svelte';
  import Community from './components/pages/Community/Community.svelte';
  import Topic from './components/pages/Topic/Topic.svelte';
  import Toasts from './components/custom/Toasts/Toasts.svelte';
  import Newsline from './components/pages/Newsline/Newsline.svelte';
  import Favorites from './components/pages/Favorites/Favorites.svelte';
  import WikiCategories from './components/pages/WikiCategories/WikiCategories.svelte';
  import WikiPublications from './components/pages/WikiPublications/WikiPublications.svelte';
  import Create from './components/pages/Editor/pages/Create/Create.svelte';
  import List from './components/pages/Editor/pages/List/List.svelte';
  import Schedule from './components/pages/Editor/pages/Schedule/Schedule.svelte';
  import NotFound from './components/pages/NotFound/NotFound.svelte';

  import { onMount } from 'svelte';
  import { api } from './helpers';
  import { info_client } from './components/stores';

  const routes = {
      '/get-access-token/:refresh_token': TokenSave,

      '/flow-program': $info_client.is_staff ? Main : FlowProgram,

      '/favorites': $info_client.is_staff ? Main : Favorites,
    
      '/': Main,

      '/community': $info_client.flow?.is_green ? Main : Community,

      '/listnews/:feed_groops': Newsline,

      '/wiki/category': WikiCategories,
      '/listwiki/:wiki_pages': WikiPublications,

      '/publicate/:publ_id': PublicatePage,

      '/token_error/': TokenError,
      '/access_error/': AccessError,
      '/logout/': Logout,
      
      '/preview_publ_from_list/:publ_id': PreviewPublicatePage,

      '/topic/:id': Topic,

      // Editor
      '/editor/create': Create,
      '/editor/edit/:id': Create,
      '/editor/list': List,
      '/editor/schedule/:id': Schedule,

      '*': NotFound,
  };

  info_client.subscribe((value) => {
    if (value.is_staff) {
      const script = document.createElement('script');
      script.src = 'https://chat.fizikl.org/embed.js';
      script.async = true;
      script.setAttribute('data-title', 'Мой чат');
      document.body.appendChild(script);
    }
  });

  onMount(() => {
    // Логирование IFrame на проекте
    window.addEventListener("blur", () => {
      setTimeout(async () => {
        const element = document.activeElement

        if (element.tagName === "IFRAME" && element instanceof HTMLIFrameElement) {
          const src = element.src
          const parent = element.parentNode

          const publication = +parent.dataset.publId
          const publication_item = +parent.dataset.itemId
          
          const path = ['/api/v1/logging/publication/create']
          const method = 'POST'
          const isJSON = true
          const body = JSON.stringify({ publication, publication_item })

          if (src.includes('youtube')) {
            path.push('/click-video/')
          }

          if (src.includes('soundcloud')) {
            path.push('/click-audio/')
          }

          await api(path.join(''), method, body, isJSON)
        }
      });
    });
  })
</script>

<Router {routes}/>
<Toasts />

<style lang="scss">
  :global(.text-bold) {
    font-weight: 600;
  }

  :global(.gap-2) {
    grid-gap: 8px;
  }

  :global(.justify-end) {
    justify-content: end;
  }

  :global(.font-normal) {
    font-weight: 400;
  }

  :global(.px-4) {
    padding-left: 16px;
    padding-right: 16px;
  }

  :global(.ml-4) {
    margin-left: 16px;
  }

  :global(.w-100) {
    width: 100%;
  }

  :global(.rounded-full) {
    border-radius: 100% !important;
  }

  :global(.flex-1) {
    flex: 1;
  }

  :global(.w-full) {
    width: 100%;
  }

  :global(.grid) {
    display: grid;
  }
  
  :global(.gap-1) {
    grid-gap: 4px;
  }

  :global(.text-grey) {
    color: #5A5F6D;
  }

  :global(.ml-xs) {
    margin-left: 4px;
  }

  :global(.ml-sm) {
    margin-left: 8px;
  }

  :global(.ml-2) {
    margin-left: 8px;
  }

  :global(.mt-2) {
    margin-top: 8px;
  }

  :global(.font-medium) {
    font-weight: 500;
  }

  :global(.left-0) {
    left: 0;
  }

  :global(.py-3) {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  :global(.ml-md) {
    margin-left: 12px;
  }

  :global(.cursor-pointer) {
    cursor: pointer;
  }

  :global(.link) {
    color: #2B50ED;
    text-decoration: underline;
    cursor: pointer;
  }
  :global(.dot) {
    padding-right: 10px;
    position: relative;
  }

  :global(.absolute) {
    position: absolute;
  }

  :global(.bg-white) {
    background-color: white;
  }

  :global(.dot::after) {
    content: '';
    position: absolute;
    width: 2px;
    height: 2px;
    background: #5A5F6D;
    border-radius: 50px;
    margin: 0 4px;
    top: 50%;
    transform: translate(-50%, -50%);
  } 

  :global(.flex) {
    display: flex;
  }

  :global(.flex-col) {
    flex-direction: column;
  }

  :global(.whitespace-nowrap) {
    white-space: nowrap;
  }

  :global(.overflow-hidden) {
    overflow: hidden;
  }

  :global(.text-ellipsis) {
    text-overflow: ellipsis;
  }
  

  :global(.justify-center) {
    justify-content: center;
  }

  :global(.justify-between) {
    justify-content: space-between;
  }

  :global(.items-center) {
    align-items: center;
  }
</style>

